import { useEffect } from 'react'

interface Props {
  needLock?: boolean
}
const useLockBodyScroll = (props: Props = { needLock: true }) => {
  const { needLock } = props
  useEffect(() => {
    if (!needLock) return () => {}

    const previousOverflowY = window.document.body.style.overflowY
    const previousPosition = window.document.body.style.position
    if (needLock) {
      window.document.body.style.overflowY = 'hidden'
      window.document.body.style.position = 'fixed'
    }

    return () => {
      window.document.body.style.overflowY = previousOverflowY
      window.document.body.style.position = previousPosition
    }
  }, [needLock])
}

export default useLockBodyScroll
